export default "__VITE_ASSET__D7fPZMbm__"